


<app-client-employee-dynamicform-list *ngIf="!CEEditList"  [ListCEInputProperty]="isListorEditView"
(ListOutputCE)="EmitChildComponent($event)"></app-client-employee-dynamicform-list>

<app-client-employee-dynamicform-edit  *ngIf="CEEditList" [EditCEInputProperty]="isListorEditView"
(EditOutputCE)="EmitChildComponent($event)"></app-client-employee-dynamicform-edit>





  
  
  

